import { minuteS } from "../../../../timeConstants.js";
import { DirectSubChannel, SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig } from "../types.js";

// ─── Sensirion SLF3S-1300F (bidirectional PWM flowmeter, R&D project) ────────
//
// Legacy calibration (SensorConfiguration.ts): result [L/min] = 0.13 * freq / 1000 - 0.065,
// with a ±0.1 Hz deadband around the 500 Hz zero-flow point forced to exactly 0.
//
// Rewritten in the same kFactor/frequencyOffset vocabulary the other flowmeter clusters use
// (result = kFactor_old * (freq + offset), see badgermeterFlowmeterClusterConfigs.ts):
//   kFactor_old [L/min per Hz] = 0.13 / 1000 = 0.00013
//   offset [Hz]                = -500 (the zero-flow frequency)
//   kFactor [L/pulse]          = kFactor_old / 60
//
// The bidirectionalFlowmeter element does not reproduce the deadband — see its testCases for the
// bounded divergence this causes, and sensorClusterMigration.test.ts for the cluster-level check.
const ZERO_FLOW_FREQUENCY_HZ = 500;
const LITERS_PER_MINUTE_PER_HERTZ = 0.13 / 1000;

export const sensirionFlowmeterClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    sensirionFlowmeterSLF3S_1300F: {
        communicationMode: SensorPortCommunicationMode.DIRECT,
        requiredSubChannels: [DirectSubChannel.PULSE_FREQUENCY],
        optionalSubChannels: [],
        isPermanentlyAttached: false,
        parameterConfigs: {},
        manufacturerName: "Sensirion",
        modelName: "SLF3S-1300F",
        friendlyName: "SLF3S Flowmeter",
        friendlyShortName: "SLF3S Flow",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "bidirectionalFlowmeter",
                parameters: {
                    kFactor: LITERS_PER_MINUTE_PER_HERTZ / minuteS,
                    frequencyOffset: -ZERO_FLOW_FREQUENCY_HZ,
                },
                legalConvertedRange: [null, null],
                subChannel: DirectSubChannel.PULSE_FREQUENCY,
            },
        ],
        migrationProperties: {
            legacySensorType: "sensirionFlowmeterSLF3S_1300F",
            legacyParametersToClusterParameters: () => ({}),
            clusterParametersToLegacyParameters: () => ({}),
        },
    },
};
